import {AdvertiserDevicesSortType} from '../../types/advertiser-devices.type';
import {OrderType} from '../../types/order.type';
import {LatLngBounds} from 'leaflet';
import {DeviceOrientation} from '@shared/enums/device-orientation.enum';

export class FetchAdvertiserFavoriteDevices {
  static readonly type = '[Advertiser favorite devices] get favorite devices';

  constructor() {
  }
}

export class SearchAdvertiserFavoriteDevices {
  static readonly type = '[Advertiser favorite devices] search favorite devices';

  constructor(public search: string) {
  }
}

export class SetAdvertiserFavoriteDevicesPage {
  static readonly type = '[Advertiser favorite devices] set favorite devices';

  constructor(public page: number) {
  }
}

export class SortAdvertiserFavoriteDevices {
  static readonly type = '[Advertiser favorite devices] sort favorite devices';

  constructor(public payload: {
    sort: AdvertiserDevicesSortType,
    order: OrderType,
  }) {
  }
}

export class SetAdvertiserMapBoundsForFavorite {
  static readonly type = '[Advertiser favorite devices] set map bounds';

  constructor(public mapBounds: LatLngBounds) {
  }
}

export class GetAdvertiserFavoriteDevicesBySubmit {
  static readonly type = '[Advertiser favorite devices] get advertiser devices by form submitting';

  constructor(public payload: {
    orientation?: DeviceOrientation | null, priceFrom?: number,
    priceTo?: number
  }) {
  }
}

export class RemoveAdvertiserFavoriteDeviceFromFavorite {
  static readonly type = '[Advertiser favorite devices] remove from favorite';

  constructor(public id: number) {
  }
}

export class CleanAdvertiserFavoriteDeviceStore {
  static readonly type = '[Advertiser favorite devices] clean store';
}
